import React, { useEffect } from 'react';

// --- CAMBIO INICIA ---
// Para los íconos, necesitamos importar los componentes Svg y Path.
// Asegúrate de tener 'react-native-svg' instalado en tu proyecto web si aún no lo tienes.
// Si no lo tienes, ejecuta: npm install react-native-svg
const Svg = (props) => <svg {...props}>{props.children}</svg>;
const Path = (props) => <path {...props} />;
// --- CAMBIO TERMINA ---

// --- CAMBIO INICIA ---
// Añadimos los componentes de los íconos, igual que en la app móvil
const GlobeIcon = ({ color = '#422e2eff', size = 50 }) => (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <Path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
      <Path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
    </Svg>
);
const TikTokIcon = ({ color = '#422e2eff', size = 50 }) => (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <Path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-2.43.05-4.84-.95-6.43-2.8-1.59-1.87-2.32-4.2-1.86-6.33.32-1.41.9-2.77 1.69-3.98 1.32-2.06 3.54-3.32 5.78-3.47.01 2.87-.01 5.74.02 8.61.08 1.43.54 2.85 1.35 4.01 1.02 1.49 2.71 2.39 4.35 2.42 1.66.03 3.34-.85 4.35-2.22.99-1.36 1.48-3.04 1.48-4.59.01-2.89-.01-5.78.02-8.66-1.48-.16-2.93-.55-4.2-1.11-.57-.26-1.1-.59-1.62-.93-.01-2.92.01-5.84-.02-8.75z" />
    </Svg>
);
const FacebookIcon = ({ color = '#422e2eff', size = 50 }) => (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <Path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </Svg>
);
// --- CAMBIO TERMINA ---

const Nosotros = () => {

    useEffect(() => {
        const audio = document.getElementById('background-music');
        if (audio) {
            audio.play().catch(error => {
                console.log("La reproducción automática de audio fue prevenida por el navegador.");
            });
        }
        return () => {
            if (audio) {
                audio.pause();
            }
        };
    }, []);

    // --- CAMBIO INICIA ---
    // Definimos las URLs para los enlaces
    const websiteUrl = 'https://hostaljallalla.netlify.app/';
    const tiktokUrl = 'https://www.tiktok.com/@jallashbbxp';
    const facebookUrl = 'https://www.facebook.com/jallalla.hostel';
    // --- CAMBIO TERMINA ---

    return (
        <div style={{ minHeight: '150vh', color: '#ffffffff' }}>
            <video
                autoPlay
                loop
                muted
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    minWidth: '100%',
                    minHeight: '100%',
                    width: 'auto',
                    height: 'auto',
                    zIndex: -1,
                    objectFit: 'cover',
                    transform: 'translate(-50%, -50%)',
                    filter: 'brightness(1.3)'
                }}
            >
                <source src="/videos/background2.mp4" type="video/mp4" />
                Tu navegador no soporta videos.
            </video>

            <audio id="background-music" loop>
                <source src="/music/melodia.mp3" type="audio/mpeg" />
            </audio>

            <div
                style={{
                    position: 'relative',
                    zIndex: 2,
                    padding: '40px 20px',
                    textAlign: 'center',
                    backgroundColor: 'rgba(255, 247, 247, 0.3)',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <h1 style={{ fontSize: '3rem', textShadow: '4px 4px 8px rgba(161, 191, 41, 0.9)' }}>
                    Sobre Nosotros
                </h1>
                <p
                    style={{
                        fontSize: '1.3rem',
                        lineHeight: '1.7',
                        maxWidth: '800px',
                        margin: '0 auto 30px auto',
                        textShadow: '4px 4px 6px rgba(0,0,0,0.8)'
                    }}
                >
                    Bienvenido al <strong>Hostal Jallalla</strong>, un lugar céntrico donde el descanso y
                    la comodidad será una prioridad. Contamos con estacionamiento (tiene un pago adicional o promoción), servicio de traslado y lavandería.
                </p>

                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px' }}>
                    <img
                        src="/images/nosotros.gif"
                        alt="Imagen del Hostal"
                        style={{
                            width: '100%',
                            maxWidth: '500px',
                            borderRadius: '50px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                            border: '3px solid white'
                        }}
                    />
                </div>

                <p
                    style={{
                        fontSize: '1.4rem',
                        maxWidth: '800px',
                        margin: '0 auto',
                        textShadow: '4px 4px 6px rgba(0,0,0,0.8)'
                    }}
                >
                    Nuestra ubicación céntrica te permitirá acceder a las mejores lugares y servicios de la ciudad. 
                    
                                                     ¡Esperamos tu visita!  🏚️🖐️
                </p>

                {/* --- CAMBIO INICIA --- */}
                {/* SECCIÓN DE ENLACES SOCIALES AÑADIDA */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    width: '100%',
                    maxWidth: '450px',
                    marginTop: '100px',
                    paddingTop: '20px',
                    borderTop: '1px solid rgba(255, 0, 0, 0.2)'
                }}>
                    <a href={websiteUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#000000ff', textAlign: 'center' }}>
                        <GlobeIcon />
                        <span style={{ display: 'block', marginTop: '5px', fontSize: '12px' }}>Web</span>
                    </a>
                    <a href={tiktokUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#000000ff', textAlign: 'center' }}>
                        <TikTokIcon />
                        <span style={{ display: 'block', marginTop: '5px', fontSize: '12px' }}>TikTok</span>
                    </a>
                    <a href={facebookUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#000000ff', textAlign: 'center' }}>
                        <FacebookIcon />
                        <span style={{ display: 'block', marginTop: '5px', fontSize: '12px' }}>Facebook</span>
                    </a>
                </div>
                {/* --- CAMBIO TERMINA --- */}

            </div>

            <div style={{ marginTop: '50px', width: '100%', maxWidth: '800px' }}>
                    <h2 style={{ fontSize: '2.5rem', textShadow: '4px 4px 8px rgba(161, 191, 41, 0.9)' }}>
                        Nuestra Ubicación
                    </h2>
                    <div style={{
                        borderRadius: '15px',
                        overflow: 'hidden', // Para que el mapa respete los bordes redondeados
                        border: '3px solid white',
                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
                        marginTop: '20px'
                    }}>
                        {/* REEMPLAZA EL IFRAME DE EJEMPLO CON EL TUYO AQUÍ */}
                        <iframe 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d756.3452551874476!2d-68.92411171694832!3d-22.46543920086767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96ac09ccf63e629d%3A0x4846e11d1d998b56!2sJallalla!5e1!3m2!1ses-419!2scl!4v1753335361406!5m2!1ses-419!2scl" 
                            width="100%" 
                            height="450" 
                            style={{ border: 0 }} 
                            allowFullScreen="" 
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Ubicación del Hostal Jallalla"
                        ></iframe>
                    </div>
                </div>
        </div>



    );

    
};

export default Nosotros;